import type { CompensationRule } from './types';

/**
 * Resolve the compensation rule in force on a given date.
 * Service-specific rules beat the practitioner default. Later effective_from
 * wins if two rules overlap. Historical rates are never rewritten in place.
 */
export function resolveCompensationRule(
  rules: CompensationRule[],
  practitionerId: string | null,
  serviceId: string | null,
  onDate: string,
): CompensationRule | null {
  if (!practitionerId) return null;
  const day = onDate.slice(0, 10);
  const applicable = rules.filter((rule) => {
    if (rule.practitioner_id !== practitionerId) return false;
    if (rule.effective_from > day) return false;
    if (rule.effective_to && rule.effective_to < day) return false;
    return rule.service_id === serviceId || rule.service_id === null;
  });
  if (applicable.length === 0) return null;
  applicable.sort((a, b) => {
    const serviceRank = Number(Boolean(b.service_id)) - Number(Boolean(a.service_id));
    if (serviceRank !== 0) return serviceRank;
    return b.effective_from.localeCompare(a.effective_from);
  });
  return applicable[0];
}

export function commissionAmountCents(
  commissionableCents: number,
  commissionPercent: number | null | undefined,
): number {
  if (commissionPercent == null || !Number.isFinite(commissionPercent)) return 0;
  return Math.round((commissionableCents * commissionPercent) / 100);
}
